import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="preview-fallback"
//
// Soft fallback for the express review "Preview" affordance. The affordance normally flips to a
// clickable button via a server broadcast when the rendered PDF is ready. If that never arrives
// (job stuck/slow), after a timeout we make the in-progress affordance clickable anyway so the
// member is never blocked — opening the modal then just shows the still-loading spinner. The
// preview is optional (Send is not gated on it).
export default class extends Controller {
  static values = {
    frameId: String,
    modalId: String,
    timeout: { type: Number, default: 45000 }
  }

  connect() {
    this.timer = setTimeout(() => this.fallback(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  fallback() {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return
    // Already resolved: "ready" is clickable; "error" means generation failed (nothing to open).
    if (["ready", "error"].includes(frame.dataset.previewState)) return

    frame.dataset.previewState = "fallback"
    const box = frame.firstElementChild
    if (!box) return
    box.setAttribute("data-action", "click->modal#show")
    box.setAttribute("data-modal-id", this.modalIdValue)
    box.classList.remove("cursor-default")
    box.classList.add("cursor-pointer", "hover:!border-core-purple-400")
    const label = box.querySelector("span")
    if (label) label.textContent = "Preview your application (still preparing…)"
  }
}
